module.exports = __webpack_public_path__ + "img/reindeer-1.cc3f76b4.png";